/* eslint-disable react/no-danger */
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { useSelector } from 'react-redux';

import { selectUser } from '../../features/auth/authSlice';
import {
  useGetGlobalQuery,
  useGetFAQQuery,
} from '../../features/my-certifications/myCertificationsApiSlice';

export function About() {
  const user = useSelector(selectUser);

  const { data } = useGetGlobalQuery(
    { apiKey: user?.apiKey },
    {
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: faq } = useGetFAQQuery(null, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });

  return (
    <div className="space-y-6 text-[#020817]">
      <header className="space-y-2">
        <p className="inline-flex rounded-full border border-[#C9D8FF] bg-[#EEF3FF] px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-[#000097]">
          Ambiente de certificação
        </p>
        <h1 className="text-3xl font-bold tracking-tight text-[#020817]">
          {data?.title} {user?.name},
        </h1>
      </header>

      {data?.description && (
        <div
          className="rounded-2xl border border-[#E2E8F0] bg-[#F8FAFF] p-5 text-base leading-relaxed text-[#334155] [&_p]:mb-3 [&_p:last-child]:mb-0"
          dangerouslySetInnerHTML={{
            __html: data?.description,
          }}
        />
      )}

      <div className="overflow-hidden rounded-2xl border border-[#C9D8FF] bg-[#020817] shadow-md">
        <iframe
          className="aspect-video w-full"
          src={data?.video_url}
          title="Bem-vindo(a)"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      {data?.regulation?.url && (
        <div className="space-y-3 rounded-2xl border border-[#C9D8FF] bg-[#EEF3FF] p-5">
          <p className="text-lg font-extrabold text-[#020817]">
            Leia o{' '}
            <a
              className="font-bold text-[#0050C0] underline decoration-[#7AA7FF] underline-offset-4 transition hover:text-[#000097]"
              href={data?.regulation?.url}
              target="_blank"
              rel="noreferrer"
            >
              Regulamento
            </a>{' '}
            completo e o{' '}
            <a
              className="font-bold text-[#0050C0] underline decoration-[#7AA7FF] underline-offset-4 transition hover:text-[#000097]"
              href={data?.manual?.url}
              target="_blank"
              rel="noreferrer"
            >
              Manual do Candidato
            </a>
            .
          </p>
          <p className="text-[#334155]">
            Abaixo seguem informações importantes para realização da prova.
            Informe-se e faça um ótimo exame!
          </p>
        </div>
      )}

      <div>
        <Accordion allowZeroExpanded className="space-y-3">
          {faq?.map(item => (
            <AccordionItem
              key={item._id}
              className="overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white shadow-sm"
            >
              <AccordionItemHeading>
                <AccordionItemButton className="px-4 py-4 text-left text-base font-semibold text-[#020817] transition hover:bg-[#F4F7FD]">
                  {item.title}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className="border-t border-[#E2E8F0] bg-[#F8FAFF] px-4 py-4 text-sm leading-relaxed text-[#334155] [&_p]:mb-3 [&_p:last-child]:mb-0">
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.content,
                  }}
                />
              </AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
